module.exports = __webpack_public_path__ + "img/va.e3cb6510.png";